"use strict";

var _classCallCheck = require("/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grammar = void 0;

var Grammar = /*#__PURE__*/function () {
  function Grammar(rules, state) {
    _classCallCheck(this, Grammar);

    this.rules = rules;
    this.state = state;
    this.mainRule = Object.keys(rules)[0];
    this.log = [];
  }

  _createClass(Grammar, [{
    key: "parse",
    value: function parse(iterator) {
      this.lexer = iterator;
      this.token = this.lexer.next();
      return this.consumeRule(this.mainRule);
    }
  }, {
    key: "matchEndOfFile",
    value: function matchEndOfFile() {
      return !this.token;
    }
  }, {
    key: "matchToken",
    value: function matchToken(type) {
      return this.token && type === this.token.type;
    }
  }, {
    key: "consumeToken",
    value: function consumeToken(type, optional) {
      var token = this.token;

      if (!type || token && token.type === type) {
        this.token = this.lexer.next();
        return token;
      } else if (optional) {
        return undefined;
      } else {
        var got = token ? "\"".concat(token.type, "\"") : 'EOF';
        var error = new SyntaxError(this.lexer.formatError(token, "expected \"".concat(type, "\", got ").concat(got)));
        error.message += " (".concat(this.log.join('->'), ")");
        throw error;
      }
    }
  }, {
    key: "consumeRule",
    value: function consumeRule(rule) {
      this.log.push(rule);
      var result = this.rules[rule].call(this);
      this.log.pop();
      return result;
    }
  }]);

  return Grammar;
}();

exports.Grammar = Grammar;